export class AppMessageSettings {
  sticky?: boolean = false; //When defined, growl messages are not removed automatically after a period defined by life option.
  life?: number = 2000; //Time to display a message in milliseconds before removing it.
}
